import { render, staticRenderFns } from "./5c_doc.vue?vue&type=template&id=d0d7951a&scoped=true"
import script from "./5c_doc.vue?vue&type=script&lang=js"
export * from "./5c_doc.vue?vue&type=script&lang=js"
import style0 from "./5c_doc.vue?vue&type=style&index=0&id=d0d7951a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d7951a",
  null
  
)

export default component.exports